import React from 'react';
import PropTypes from 'prop-types';

const DealerDetails = ({ dealersDetails, setDealersDetails, showPopup, setShowPopup, cursorPosition  }) => {

    if (!dealersDetails || !showPopup) return null;
    const handleClose = (e) => {
        e.stopPropagation();
        setDealersDetails([]);
        setShowPopup(false);
    };

    const style = {
        position: 'fixed',
        top: `${cursorPosition.y + 10}px`,
        left: `${cursorPosition.x + 10}px`,
        zIndex: 999,
    };

    return (
        <div className='tr-hover-alert' style={style} onClick={e => e.stopPropagation()}>
            <div className='tr-card'>
                <button className='close-icon' onClick={handleClose} aria-label="Close">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <mask id="mask0_12046_372" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                            <rect width="18" height="18" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_12046_372)">
                            <path d="M9.0001 10.0501L5.3251 13.7251C5.1876 13.8626 5.0126 13.9313 4.8001 13.9313C4.5876 13.9313 4.4126 13.8626 4.2751 13.7251C4.1376 13.5876 4.06885 13.4126 4.06885 13.2001C4.06885 12.9876 4.1376 12.8126 4.2751 12.6751L7.9501 9.0001L4.2751 5.3251C4.1376 5.1876 4.06885 5.0126 4.06885 4.8001C4.06885 4.5876 4.1376 4.4126 4.2751 4.2751C4.4126 4.1376 4.5876 4.06885 4.8001 4.06885C5.0126 4.06885 5.1876 4.1376 5.3251 4.2751L9.0001 7.9501L12.6751 4.2751C12.8126 4.1376 12.9876 4.06885 13.2001 4.06885C13.4126 4.06885 13.5876 4.1376 13.7251 4.2751C13.8626 4.4126 13.9313 4.5876 13.9313 4.8001C13.9313 5.0126 13.8626 5.1876 13.7251 5.3251L10.0501 9.0001L13.7251 12.6751C13.8626 12.8126 13.9313 12.9876 13.9313 13.2001C13.9313 13.4126 13.8626 13.5876 13.7251 13.7251C13.5876 13.8626 13.4126 13.9313 13.2001 13.9313C12.9876 13.9313 12.8126 13.8626 12.6751 13.7251L9.0001 10.0501Z" fill="#1C1B1F" />
                        </g>
                    </svg>
                </button>

                {dealersDetails && (
                    <div className="dealers-list">
                        {dealersDetails.map((dealer, index) => (
                            <div key={dealer.siteUserId || index} className="dealer-details"> 
                                <b>{dealer?.fullName}</b>
                                {(dealer?.salesContactEmail || dealer?.salesContactPhone) && (
                                    <div className='form-group'>
                                        <label>Sales Contact:</label>
                                        {dealer?.salesContactPhone && (
                                            <p className='mb-0'>
                                                <span>Phone: </span>
                                                <span>{dealer.salesContactPhone}</span>
                                            </p>
                                        )}
                                        {dealer?.salesContactEmail && (
                                            <p className='mb-0'>
                                                <span>Email: </span>
                                                <span>{dealer.salesContactEmail}</span>
                                            </p>
                                        )}
                                    </div>
                                )}
                                {(dealer?.pmContactEmail || dealer?.pmContactPhone) && (
                                    <div className='form-group'>
                                        <label>PM Contact:</label>
                                        {dealer?.pmContactPhone && (
                                            <p className='mb-0'>
                                                <span>Phone: </span>
                                                <span>{dealer.pmContactPhone}</span>
                                            </p>
                                        )}
                                        {dealer?.pmContactEmail && (
                                            <p className='mb-0'>
                                                <span>Email: </span>
                                                <span>{dealer.pmContactEmail}</span>
                                            </p>
                                        )}
                                    </div>
                                )}
                                {index < dealersDetails.length - 1 && <hr />}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

DealerDetails.propTypes = {
    dealersDetails: PropTypes.arrayOf(
        PropTypes.shape({
            siteUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            fullName: PropTypes.string,
            salesContactPhone: PropTypes.string,
            salesContactEmail: PropTypes.string,
            pmContactPhone: PropTypes.string,
            pmContactEmail: PropTypes.string,
        })
    ),
    setDealersDetails: PropTypes.func.isRequired, 
    showPopup: PropTypes.bool.isRequired,
    setShowPopup: PropTypes.func.isRequired,

    // 👇 Add this block
    cursorPosition: PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired,
    }).isRequired,
};
export default DealerDetails;